(function($, undefined) {

	'use strict';
	var openPopupClickBtn;
	var openPopupHoverBtn;
	var closePopupBtn;

	var openPopup = function() {
		var t = $(this);
		var id = t.attr('data-id');
		var popup = $('.popup-outer[data-id=' + id + ']');
        var key = t.attr('data-key');
        var insText = t.attr('data-insert-text');

		popup.addClass('open');
        
        if (key) {
            popup.find('.popup-lock').val(key);
        }
        if (insText) {
            popup.find('.popup-insert-text').text(insText);
        }
        
		if (t.hasClass('hover') && !$('html').hasClass('mobile')) {
			popup.find('.popup').mouseleave(closePopup);
		}
	};

	var closePopup = function() {
		var t = $(this);
		var popup = t.closest('.popup-outer');

		popup.removeClass('open');
	};
	
	var showSuccessPopup = function(successClass) {
		var success = successClass;
		if (success === undefined) {
			success = 'form-success';
		}
		
		showPopupAnimation(success);
	};
	
	var showErrorPopup = function(errorClass) {
		var error = errorClass;
		if (error === undefined) {
			error = 'form-error';
		}
		
		showPopupAnimation(error);
	};
	
	var showPopupAnimation = function(messageClass) {
		var message = $('.form-popup-message.'+ messageClass);

		$('.form-popup-message').removeClass('show');
		message.addClass('show');
		
		setTimeout(function () {
			message.removeClass('show');
		}, 5000);
	};
	
	var closeMsgPopup = function () {
		$(this).closest('.form-popup-message').removeClass('show');
		var qkey = this.getAttribute('data-qkey');
		if (qkey && qkey !== '') {
			Fw.component.models().utils.changeURLState(qkey, null, {});
		}
	};

	var init = function() {
		openPopupClickBtn = $('.open-popup-btn:not(.hover), html.mobile .open-popup-btn.hover');
		openPopupHoverBtn = $('html:not(.mobile) .open-popup-btn.hover');
		closePopupBtn = $('.close-popup-btn');

		openPopupClickBtn.click(openPopup);
		openPopupHoverBtn.mouseover(openPopup);
		closePopupBtn.click(closePopup);
		$('.form-popup-message-close-btn').click(closeMsgPopup);
	};
    
	Fw.component.export('popup', {
		openPopup,
		closePopup,
		showSuccessPopup,
        showErrorPopup,
        closeMsgPopup
	});
	
	$(window).ready(init);

})(jQuery);

